import PropTypes from 'prop-types';
import React from 'react';
import { Icon, SnackbarContainer } from '@mch-group/uikit-components';
import { Text } from '@dmi-mch/components';
import styled from 'styled-components';

var NotificationMessage = function NotificationMessage(_ref) {
  var header = _ref.header,
      content = _ref.content,
      className = _ref.className,
      show = _ref.show,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'green' : _ref$color,
      ctaLabel = _ref.ctaLabel,
      ctaAction = _ref.ctaAction,
      closeClickCallback = _ref.closeClickCallback,
      showCloseButton = _ref.showCloseButton;
  var cssClass = "".concat(header ? 'message-with-header' : 'message-with-content', " ").concat(ctaAction ? '' : 'no-cta');

  if (!show) {
    return null;
  }

  return /*#__PURE__*/React.createElement(SnackbarContainer, {
    position: "top-end",
    className: "".concat(className, " text-white me-8"),
    style: {
      backgroundColor: color
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "".concat(cssClass),
    style: {
      backgroundColor: color,
      borderRadius: 5
    }
  }, header && /*#__PURE__*/React.createElement("h5", {
    className: "fw-bold text-center mb-3 text-white"
  }, header), /*#__PURE__*/React.createElement("div", {
    className: "left"
  }, /*#__PURE__*/React.createElement(Text, {
    className: "content label label-1",
    isHtml: true
  }, content), ' ', ctaLabel && /*#__PURE__*/React.createElement("button", {
    className: "call-to-action",
    onClick: ctaAction
  }, /*#__PURE__*/React.createElement("b", null, ctaLabel)), showCloseButton && /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: "close",
    onClick: closeClickCallback
  }, /*#__PURE__*/React.createElement(Icon, {
    name: "close"
  })))));
};

var NotificationMessageStyled = styled(NotificationMessage).withConfig({
  displayName: "NotificationMessage__NotificationMessageStyled",
  componentId: "sc-1harcrm-0"
})(["position:fixed !important;text-align:left;z-index:10;padding:0 !important;border-radius:6px !important;display:unset !important;background-color:#1d2327;@media (min-width:768px){width:343px;", "}@media (max-width:767px){width:95%;bottom:8px;left:50%;transform:translateX(-50%);}.message-with-header{padding-top:12px;padding-left:12px;.header{margin-bottom:12px;margin-top:0;", "}.left{padding-bottom:12px;}}.content.label.label-1{font-weight:normal !important;}.message-with-content{display:flex;&.no-cta{button{border-left:1px solid #444749;}}.left{display:flex;width:100%;min-height:80px;align-items:center;> .content{margin:18px 0 18px 20px;align-self:center;width:250px;color:white;line-height:18px;@media (max-width:991px){width:calc(100% - 130px);}}> .call-to-action{border-right:1px solid #444749;height:100%;width:80px;margin-left:auto;b{color:white;}}}}button{color:inherit;cursor:pointer;font-size:inherit;border:inherit;background:transparent;font-family:inherit;}.close{width:50px;height:100%;margin-left:auto;svg{fill:#fff !important;margin:0 !important;}}"], function (_ref2) {
  var alignTopCenter = _ref2.alignTopCenter;
  return alignTopCenter ? 'top: 146px ; left: 50% ; transform: translate(-50%,0px)' : 'top: 146px ; right: 30px ';
}, function (_ref3) {
  var alignTopCenter = _ref3.alignTopCenter;
  return alignTopCenter ? 'text-align: center' : 'text-align: left';
});
NotificationMessage.propTypes = {
  showMessage: PropTypes.object,
  className: PropTypes.string,
  header: PropTypes.string,
  content: PropTypes.string,
  show: PropTypes.bool,
  color: PropTypes.string,
  ctaLabel: PropTypes.string,
  closeClickCallback: PropTypes.func,
  ctaAction: PropTypes.func,
  showCloseButton: PropTypes.bool,
  alignTopCenter: PropTypes.bool,
  bgColor: PropTypes.string
};
export default NotificationMessageStyled;